export const UPTODATE = 0
export const OUTDATED = 1
export const UNVERIFIED = 2
